import { lazy } from 'react'

import Loadable from '../components/Loadable'
import MinimalLayout from '../layout/MinimalLayout'

const PublicClientFormPage = Loadable(lazy(() => import('pages/client/PublicClientFormPage')))
const PublicAppointmentConfirmPage = Loadable(lazy(() => import('pages/client/PublicAppointmentConfirmPage')))

const PublicFormRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: 'client-form/:token',
      element: <PublicClientFormPage />
    },
    {
      path: 'appointment-confirm/:token',
      element: <PublicAppointmentConfirmPage />
    }
  ]
}

export default PublicFormRoutes
